import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
  Input,
} from "reactstrap";
import moment from "moment";
import { CALL_REPORT } from "../../helpers/url_helper";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  formatDate,
  formatDateTime,
} from "../../Components/Common/FormDateTime";
import EmployeeSelect from "../../Components/Common/EmployeeSelect";
import TeamSelect from "../../Components/Common/TeamSelect";
import EmployeeCallType from "../../Components/Common/EmployeeCallType";
import { DatePicker } from "../../Components/Common/Flatpicker";
import { APIClient, exportReport } from "../../helpers/api_helper";
import {
  CurrentDate,
  PreviousDate,
} from "../../Components/Common/DefaultDateSet";
import { HandleErrorMessage } from "../../Components/Common/HandleErrorMessage";
import {
  formatToSystemTimezone,
  toCamelCase,
} from "../../Components/Common/ToCamelCase";
import SubExpired from "../../Components/Common/subExpired";
import { useLocation, useNavigate } from "react-router-dom";
import { useProfileData } from "../../Components/Hooks/UserHooks";
import CommanDataTable from "../../Components/Common/DataTable";
import { addMonths } from "../../Components/Common/FlatePicker";
import { handleExport } from "../../Components/Common/validationSchema";
import { curry } from "lodash";
import CalculateRemainingDays from "../../Components/Common/CalculateRemainingDays";
 
const api = new APIClient();
 
const CallReport = () => {
  document.title = "Call Report";
  const navigate = useNavigate();
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const viewReportPermission = permissionType?.includes("VIEW_REPORT");
  const loginType = JSON.parse(localStorage.getItem("logintype"));
  const { profileData } = useProfileData();
  const BooleanWithSingleEmployeeLogin =
    loginType === "employee" && permissionType.length === 0;
  const previewsDate = PreviousDate();
  const currentDate = CurrentDate();
 
  const params = new URLSearchParams(window.location.search);
  const date = params.get("date"); // Retrieve the 'date' parameter
 
  // filter data
  const [selectedFromDate, setSelectedFromDate] = useState(
    previewsDate + "T00:00:00"
  );
  const [selectedToDate, setSelectedToDate] = useState(
    currentDate + "T23:59:59"
  );
  const [selectedFromDateTwo, setSelectedFromDateTwo] = useState(
    previewsDate + "T00:00:00"
  );
  const [selectedToDateTwo, setSelectedToDateTwo] = useState(
    currentDate + "T23:59:59"
  );
  const [appliedCallType, setAppliedCallType] = useState([]);
 
  const location = useLocation();
 
  let { selectedDate, employee } = location.state || {};
  const employeeOptions = employee?.map((userid) => userid?.id);
  const convertToISODate = (dateString) => {
    const dateObject = new Date(dateString);
 
    if (!isNaN(dateObject)) {
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const day = String(dateObject.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return null;
  };
 
  //Redirection States
 
  const [isoDates, setIsoDates] = useState(convertToISODate(selectedDate));
  const [empId, setEmpId] = useState(employeeOptions);
  const [employeeDetails, setEmployeeDetails] = useState(employee);
 
  const [EmployeeData, setEmployeeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
 
  const [callHData, setCallHData] = useState([]);
 
  // callType state
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [prevEmployeesIds_Test, setPrevEmployeesIds_Test] = useState([]);
 
  // employee select
  const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
  const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);
  // Pagination settings
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFirstEffectRun, setIsFirstEffectRun] = useState(false);
  const [error, setError] = useState("");
 
  //select team state Not working
  const [teamIndu, setTeamIndu] = useState([]);
  const [EmployeeDefaultWithoutTeam, setEmployeeDefaultWithoutTeam] = useState(
    []
  );
  //search field state
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
 
 
  const remainingDays = CalculateRemainingDays();
  // flatPicker DateTime
  const formattedStartTime = formatDateTime(selectedFromDate);
  let formattedEndTime = formatDateTime(selectedToDate);
 
  const [appliedFilters, setAppliedFilters] = useState({
    startDate: formatDate(selectedFromDate),
    endDate: formatDate(selectedToDate),
    startTime: formattedStartTime,
    endTime: formattedEndTime,
    employeeIds: [],
    callType: [],
  });
 
 const handleFromDateChange = (dates) => {
  const newFromDate = dates[0];
  setSelectedFromDate(newFromDate);
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  const threeMonthsAfterFromDate = addMonths(newFromDate, 3);

  if (selectedToDate >= newFromDate && selectedToDate <= threeMonthsAfterFromDate) {
    return; 
  }
  const newToDate = threeMonthsAfterFromDate > today ? today : threeMonthsAfterFromDate;
  setSelectedToDate(newToDate);
};
 
  const handleToDateChange = (dates) => {
    const newToDate = new Date(dates);
    newToDate.setHours(23, 59, 59, 999);
    setSelectedToDate(newToDate);
  };
 
  //table data
  const column = [
    {
      name: <span className="font-weight-bold fs-13"> SN.</span>,
      width: "5%",
      selector: (row, index) => index + 1,
    },
 
    {
      name: <span className="font-weight-bold fs-13">Employee</span>,
      selector: (row) => toCamelCase(row?.employeeName),
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.employeeName}
          </h5>
          <h6 className="text-center- font-weight-bold fs-13">
            {row?.countryCode + `-` + row?.employeeNumber}
          </h6>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13"> Team Name</span>,
      selector: (row, index) => row.team,
    },
    {
      name: <span className="font-weight-bold fs-13">Client Name</span>,
      selector: (row) => toCamelCase(row?.name),
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.name}
          </h5>
          <h6 className="text-center- font-weight-bold fs-13">
            {row?.phoneNumber}
          </h6>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Date & Time</span>,
      selector: (row) => new Date(`${row?.date} ${row?.time}`).getTime(), // Timestamp for sorting
      cell: (row) => (
        <div className="mt-2 mb-2">
          <h5
            className="font-weight-bold fs-13"
            style={{ textTransform: "capitalize" }}
          >
            {row?.date}
          </h5>
          <h6 className="text-center font-weight-bold fs-13">{row?.time}</h6>
        </div>
      ),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Call Type </span>,
      selector: (cell) => {
        switch (cell.type) {
          case "OUTGOING":
            return (
              <>
                <div style={{ textTransform: "capitalize" }}>
                  {" "}
                  <i className="mdi mdi-phone-outgoing sn-out-going-text" />{" "}
                  <span className="badge badge-soft-info sn-out-going-call">
                    {" "}
                    {cell.type}
                  </span>
                </div>
              </>
            );
          case "REJECTED":
            return (
              <>
                <i className="mdi mdi-phone-remove sn-out-rejected-text" />
                <span className="badge badge-soft-warning sn-out-rejected-call">
                  {" "}
                  {cell.type}{" "}
                </span>
              </>
            );
          case "MISSED":
            return (
              <>
                <i className="mdi mdi-phone-missed sn-out-missed-text" />
                <span className="badge badge-soft-danger sn-out-missed-call">
                  {" "}
                  {cell.type}{" "}
                </span>
              </>
            );
          case "INCOMING":
            return (
              <>
                <i className="mdi mdi-phone-incoming text-success" />
                <span className="badge badge-soft-success sn-out-incoming-call">
                  {" "}
                  {cell.type}{" "}
                </span>
              </>
            );
          default:
            return (
              <span className="badge badge-soft-success"> {cell.type} </span>
            );
        }
      },
      width:'200px'
    },
    // for status //
    // {
    //   name: <span className='font-weight-bold fs-13'>Status</span>,
    //   selector: (cell) => {
    //     switch (cell.status) {
    //       case "DELETED":
    //         return <span className="badge bg-danger"> {cell.status} </span>;
    //       case "NOT UPDATED":
    //         return <span className="badge bg-info"> {cell.status} </span>;
    //       case "FOUND":
    //         return <span className="badge bg-success"> {cell.status} </span>;
    //       default:
    //         return <span className="badge bg-success"> {cell.status} </span>;
    //     }
    //   },
    // }
    // },
    {
      name: <span className="font-weight-bold fs-13">Call Recording</span>,
      width: "37%",
      selector: (row) => (
        <>
          {row?.recording ? (
            <div
              style={{
                display: "inline-grid",
                marginBottom: "20px",
                marginTop: "10px",
              }}
            >
              <span style={{ height: "10px" }}>{row?.duration}</span>
              <audio
                style={{ height: "40px", marginTop: "15px" }}
                src={row?.recording}
                controls
              />
            </div>
          ) : row?.duration && row.duration !== "00:00:00" ? (
            <div
              style={{
                display: "inline-grid",
                marginBottom: "20px",
                marginTop: "10px",
              }}
            >
              {["OUTGOING", "INCOMING", "REJECTED", "MISSED"].includes(
                row.type
              ) ? (
                <>
                  <span style={{ height: "10px" }}>{row?.duration}</span>
                  <span style={{ marginTop: "10px", color: "warning" }}>
                    Recording sync in progress...
                  </span>
                </>
              ) : (
                "Call Not Connected"
              )}
            </div>
          ) : (
            "Call Not Connected"
          )}
        </>
      ),
    },
    {
      name: (
        <span className="font-weight-bold fs-13" style={{ textAlign: "left" }}>
          Notes
        </span>
      ),
      selector: (row) => row.notes,
      sortable: true,
      cell: (row) => (
        <div style={{ textAlign: "left", width: "100%" }}>{row.notes}</div>
      ),
    },
  ];
 
  // this use Effect is only run in the condition where the (loginType === "employee") && (permissionType.length === 0)
  useEffect(() => {
    if (BooleanWithSingleEmployeeLogin) {
      callHistoryData(currentPage, perPage, profileData._id);
    }
  }, [profileData]);
  
  useEffect(() => {
    if (selectedDate) {
      navigate(location.pathname, { replace: true });
    }
  }, []);
 
  // Debounce search query
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
      setCurrentPage(1);
    }, 500);
 
    return () => {
      clearTimeout(handler);
    };
  }, [query]);
 
  // Fetch data when debounced query, currentPage, or perPage changes
  const fetchData = async () => {
    if (debouncedQuery.length >= 3 || debouncedQuery.length === 0) {
      try {
        let defaultId;
        if (employeeDetails && isoDates) {
          defaultId = empId ? empId : [];
        } else {
          defaultId =
            prevEmployeesIds_Test.length > 0
              ? prevEmployeesIds_Test
              : selectedEmployeeOptions2?.map((option) => option?.id) || []; // EmployeeData
        }
        if (selectedEmployeeOptions.length === 0) {
          defaultId = [];
        }
        await callHistoryData(
          currentPage,
          perPage,
          defaultId,
          "",
          debouncedQuery,
          appliedFilters
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
 
  useEffect(() => {
    if (!isFirstEffectRun && EmployeeData?.length > 0) {
      const updatedIds =
        teamIndu.length === 0
          ? EmployeeDefaultWithoutTeam?.map((userid) => userid?.id)
          : EmployeeData?.map((userid) => userid?.id);
 
      setAppliedFilters((prev) => ({
        ...prev,
        employeeIds: updatedIds,
      }));
 
      callHistoryData(1, perPage, updatedIds, "", "", {
        ...appliedFilters,
        employeeIds: updatedIds,
      });
 
      setPrevEmployeesIds_Test(updatedIds);
      setSelectedEmployeeOptions2(EmployeeData);
      setIsFirstEffectRun(true);
    }
  }, [EmployeeData]);
 
  useEffect(() => {
    if (isFirstEffectRun === true) {
      fetchData();
      setSelectedEmployeeOptions(
        employeeDetails ? employeeDetails : selectedEmployeeOptions
      );
    }
    if (BooleanWithSingleEmployeeLogin) {
      callHistoryData(currentPage, perPage, "", profileData._id);
    }
    fetchData();
  }, [debouncedQuery, currentPage, perPage]);
 
 
  // Search field handler
  const handleSearch = (e) => {
    setQuery(e.target.value);
  };
 
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
 
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };
 
  useEffect(() => {
    if (employeeDetails?.length > 0) {
      if (empId === "" && employeeDetails.length === 0) {
        callHistoryData(
          currentPage,
          perPage,
          "",
          selectedEmployeeOptions2?.map((userid) => userid?.id)
        );
      } else {
        callHistoryData(
          currentPage,
          perPage,
          "",
          employeeDetails?.map((userid) => userid?.id)
        );
      }
    }
  }, [empId, currentPage, perPage]);
 
  //handle submit
 
  const handleSubmit = () => {
    const baseFilters = {
      startDate: formatDate(selectedFromDate),
      endDate: formatDate(selectedToDate),
      startTime: formattedStartTime,
      endTime: formattedEndTime,
      callType: selectedOptions?.map((option) => option?.value) || [],
    };
  
    if (BooleanWithSingleEmployeeLogin) {
      const newFilters = {
        ...baseFilters,
        employeeIds: [profileData._id],
      };
  
      setAppliedFilters(newFilters); // Update filters
      callHistoryData(currentPage,perPage, "", [profileData._id], "", newFilters);
      setPerPage(10);
      setCurrentPage(1);
    } else {
      if (selectedEmployeeOptions.length === 0) {
        setError("You must select at least one");
      } else {
        const updatedIds = selectedEmployeeOptions?.map((userid) => userid?.id);
        const newFilters = {
          ...baseFilters,
          employeeIds: updatedIds,
        };
  
        setAppliedFilters(newFilters); // Update filters
        setPrevEmployeesIds_Test(updatedIds);
        setSelectedFromDateTwo(formatDate(selectedFromDate));
        setSelectedToDateTwo(formatDate(selectedToDate));
        setAppliedCallType(selectedOptions);
        setEmpId("");
  
        setCurrentPage(1);
        setSelectedEmployeeOptions2(selectedEmployeeOptions);
        setPerPage(10);
        setError("");
      }
    }
  };
    
  // Modify API call function
  const callHistoryData = async (
    page,
    size = perPage,
    defaultId,
    updatedIds,
    searchTerm = "",
    filters
  ) => {
    setIsLoading(true);
    try {
      let data = {
        startDate: isoDates?isoDates: filters.startDate,
        endDate: isoDates?isoDates:filters.endDate,
        startTime: filters.startTime,
        endTime: filters.endTime,
        callType: filters.callType,
        employeeIds: empId?empId: filters.employeeIds,
      };
 
      const response = await api.create(
        `${CALL_REPORT}?pg=${page}&lm=${size}&query=${searchTerm}`,
        data
      );
      if (response?.success) {
        const apiResponse = response.data;
        const tableData = (apiResponse?.paginatedResults || [])?.map(
          (item) => ({
            employeeName: Array.isArray(item?.employeeDescription)
              ? item.employeeDescription[0]?.fullName
              : "unknown",
            employeeNumber: Array.isArray(item?.employeeDescription)
              ? item.employeeDescription[0]?.mobileNumber
              : "-",
            name: item?.name || "unknown",
            phoneNumber: item?.phoneNumber || "-",
            date: item.dateTime
              ? moment(item.dateTime).format("DD MMM YYYY")
              : "-",
            time: formatToSystemTimezone(item.dateTime) || "-",
            duration: new Date(item.duration * 1000)
              .toISOString()
              .slice(11, 19),
            type: item?.type || "-",
            notes: item?.note || "-",
            status: item.recordingStatus?.replace(/_/g, " ") || "-",
            recording: item?.callRecording,
            countryCode: item?.employeeDescription[0].countryCode,
            team:item?.employeeDescription[0]?.team[0] || 'No Team'
          })
        );
 
        setCallHData(tableData);
        setTotalRows(apiResponse.totalCount);
      }
    } catch (error) {
      if (!remainingDays === 0) {
        HandleErrorMessage(error);
      }
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    const defaultId = empId
      ? empId
      : selectedEmployeeOptions?.map((userid) => userid?.id) || [];
      
    setIsLoading(true); 
    callHistoryData(currentPage, perPage, defaultId, "", "", appliedFilters);
  }, [currentPage, perPage,empId,appliedFilters]);
  


  //reset button
  const resetInputHistory = () => {
    setSelectedToDate("");
    setSelectedFromDate("");
    setSelectedOptions([]);
    setSelectedEmployeeOptions([]);
    setTeamIndu([]);
    setEmployeeDetails([]);
  };
 

  const handleClose = () => {
    setIsExpiredModalOpen(false);
    navigate("/planPackage");
  };
 

  //export in excel
  const handleExcelExport = async () => {
    const updatedIds = selectedEmployeeOptions2.map((userid) => userid?.id);
    const callTy = selectedOptions?.map((option) => option?.value) || [];
    await handleExport({
      type: "excel",
      apiUrl: `${CALL_REPORT}`,
      startDate: isoDates ? isoDates : selectedFromDate,
      endDate: isoDates ? isoDates : selectedToDate,
      callType: callTy,
      employeeIds: empId ? empId : updatedIds,
      fileName: "CallLogReportss.xlsx",
      // startTime: formattedStartTime,
      // endTime: formattedEndTime,
    });
  };
 

  // export in pdf
  const handlePdfExport = async () => {
    const updatedIds = selectedEmployeeOptions2.map((userid) => userid?.id);
    const callTy = selectedOptions?.map((option) => option?.value) || [];
    await handleExport({
      type: "pdf",
      apiUrl: `${CALL_REPORT}`,
      startDate: isoDates ? isoDates : selectedFromDate,
      endDate: isoDates ? isoDates : selectedToDate,
      callType: callTy,
      employeeIds: empId ? empId : updatedIds,
      fileName: "CallLogReportss.pdf",
      // startTime: formattedStartTime,
      // endTime: formattedEndTime,
    });
  };
 
  
  return (
    <React.Fragment>
      {remainingDays === 0 && isExpiredModalOpen && (
        <SubExpired
          onClose={handleClose}
          profileData={profileData?.selectedPlanDetails?.planName}
          remainingDays={remainingDays}
        />
      )}
      <div className="page-content sn-call-report-page-top">
        <Container fluid>
          <BreadCrumb title="Call Logs Report" pageTitle="Call Report" />
 
          <Card className="h-100">
            <CardBody>
              {isoDates ? (
                <button
                  className="btn btn-sm border border-rounded shadow backbtn-main mb-4"
                  onClick={() => navigate(-1)}
                >
                  <i className="ri-arrow-left-line m-1"></i> Back
                </button>
              ) : (
                ""
              )}
              <Row className="sn-header-select-employess-home sn-team-managment-tble sn-top-inputs-heading">
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2">
                  <DatePicker
                     labelContent="From Date"
                     getDate={isoDates ? isoDates : selectedFromDate}
                     options={{
                       disable: [
                         {
                           from: new Date(),
                         },
                       ],
                       dateFormat: "Y-m-d", // Backend-friendly format
                       altInput: true, // Enables the alternative display
                       altFormat: "d M, Y", // Desired display format (e.g., 04 Jan, 2025)
                       maxDate: new Date(
                         new Date().setDate(new Date().getDate())
                       ),
                     }}
                     onChange={handleFromDateChange}
                  />
                </div>
 
                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                <DatePicker
                    labelContent="To Date"
                    getDate={isoDates ? isoDates + "T23:59:59" : selectedToDate}
                    options={{
                      enable: selectedFromDate
                        ? [
                            {
                              from: isoDates ? isoDates : selectedFromDate,
                              to: addMonths(
                                isoDates ? isoDates : selectedFromDate,
                                3
                              ),
                            },
                          ]
                        : [
                            {
                              from: new Date(),
                            },
                          ],
                      dateFormat: "Y-m-d", // Backend-friendly format
                      altInput: true, // Enables an alternative input field for formatted display
                      altFormat: "d M, Y", // Desired display format (e.g., 04 Jan, 2025)
                      maxDate:
                        selectedToDate > new Date()
                          ? selectedToDate
                          : new Date(),
                    }}
                    onChange={handleToDateChange}
                  />
                </div>
 
                {((viewReportPermission && loginType === "employee") ||
                  loginType === "organization") && (
                  <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                    <TeamSelect
                      setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                      setSelectedOptions={setSelectedOptions}
                      teamIndu={teamIndu}
                      setTeamIndu={setTeamIndu}
                      labelContent="Select Team"
                    />
                  </div>
                )}
 
                {((viewReportPermission && loginType === "employee") ||
                  loginType === "organization") && (
                  <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                    <EmployeeSelect
                      EmployeeDefault={
                        teamIndu.length === 0
                          ? EmployeeDefaultWithoutTeam
                          : EmployeeData
                      }
                      setEmployeeDefault={setEmployeeData}
                      teamIndu={teamIndu}
                      // selectedEmployeeOptions={selectedEmployeeOptions}
                      setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                      setSelectedEmployeeOptions2={setSelectedEmployeeOptions2}
                      labelContent="Select Employee"
                      error={error}
                      setError={setError}
                      EmployeeDefaultWithoutTeam={EmployeeDefaultWithoutTeam}
                      setEmployeeDefaultWithoutTeam={
                        setEmployeeDefaultWithoutTeam
                      }
                      setEmployeeDetails={setEmployeeDetails}
                      selectedEmployeeOptions={
                        employeeDetails
                          ? employeeDetails
                          : selectedEmployeeOptions
                      }
                    />
 
                    {/* <EmployeeSelect
                      setEmployeeDetails={setEmployeeDetails}
                      EmployeeDefault={EmployeeData}
                      setEmployeeDefault={setEmployeeData}
                      teamIndu={teamIndu}
                      selectedEmployeeOptions={
                        employeeDetails
                          ? employeeDetails
                          : selectedEmployeeOptions
                      }
                      setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                      setSelectedEmployeeOptions2={setSelectedEmployeeOptions2}
                      labelContent="Select Employee"
                      error={error}
                      setError={setError}
                    /> */}
                  </div>
                )}
 
                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 sn-header-select-employess-home">
                  <FormGroup>
                    <EmployeeCallType
                      labelContent="Select Call Type"
                      selectedOptions={selectedOptions}
                      setSelectedOptions={setSelectedOptions}
                    />
                  </FormGroup>
                </div>
 
                <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 col-xs-12">
                  <FormGroup>
                    <Label for="exampleSelect"></Label>
                    <div
                      id="exampleSelect"
                      className="sn-call-apply-btn-reset mt-2"
                    >
                      <Button
                        id="exampleSelect"
                        type="submit"
                        color="danger"
                        className=""
                        onClick={handleSubmit}
                        disabled={isLoading}
                      >
                        Apply
                      </Button>
                      <Button
                        className=""
                        style={{ marginLeft: "10px" }}
                        id="exampleSelect"
                        outline
                        color="danger"
                        onClick={resetInputHistory}
                        disabled={isLoading}
                      >
                        Reset
                      </Button>
                    </div>
                  </FormGroup>
                </div>
              </Row>
 
              <Row className="sn-user-tble-manin-manage">
                <Col lg={12}>
                  <div className="text-end">
                    {callHData?.length > 0 ? (
                      <div
                        className="sales-ninja-tble-export-btn call-logs-report-export-exe"
                        style={{ marginTop: "7px", marginLeft: "15px" }}
                      >
                        {" "}
                        <Button
                          onClick={handleExcelExport}
                          className="custom-button tble-export1 sn-report-export-btn-new"
                        >
                          <i className="ri-file-excel-line"></i>
                        </Button>{" "}
                        &nbsp;
                        <Button
                          onClick={handlePdfExport}
                          className="custom-button ml-2 tble-export1 tble-export2 sn-report-export-btn-new button-file-export-pdf"
                        >
                          <i className="las la-file-pdf"></i>
                        </Button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="sn-call-logs-report-tble-common-isuee">
                    <CommanDataTable
                      perPage={perPage}
                      setCurrentPage={setCurrentPage}
                      column={column}
                      tableData={callHData}
                      handleSearch={handleSearch}
                      searchText={query}
                      handlePerRowsChange={handlePerRowsChange}
                      totalRows={totalRows}
                      currentPage={currentPage}
                      isLoading={isLoading}
                      handlePageChange={handlePageChange}
                      noData="There are no records to display"
                      inputClass={
                        (callHData && callHData.length > 0) || query
                          ? "d-block"
                          : "d-none"
                      }
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};
 
export default CallReport;
 